module.exports = __webpack_public_path__ + "img/product-preview-82.2a5edf9.png";